import React from 'react';
import ReactPlayer from 'react-player';
import { Link } from 'react-router-dom';
import { Play } from 'lucide-react';

const VideoSection = () => {
  // Placeholder video URL - will be replaced with Supabase integration later
  const videoUrl = "https://www.youtube.com/watch?v=dQw4w9WgXcQ";

  return (
    <div className="py-16 bg-gray-100">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Experience Isuzu</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover the innovation, reliability, and performance that make Isuzu vehicles the preferred choice
          </p>
        </div>

        <div className="flex justify-center mb-8">
          <div className="w-full max-w-4xl">
            <ReactPlayer
              url={videoUrl}
              width="100%"
              height="500px"
              controls={true}
              playing={false}
              light={true} // Shows thumbnail instead of loading video immediately
            />
          </div>
        </div>

        <div className="text-center">
          <Link 
            to="/videos" 
            className="inline-flex items-center bg-[#E62E2D] text-white px-6 py-3 rounded-md hover:bg-[#cc2827] transition duration-300"
          >
            <Play className="mr-2" size={20} />
            View All Videos
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VideoSection;